import React, {useEffect} from "react";
import UserManagerPage from "./UserManagerPage";
import {useQuery} from "@apollo/client";
import {USER_MANAGER_GRID_MATRIX_QUERY} from "../../schemas/userManager";


const UserManagerGridMatrix: React.FC<any> = () => {
    const { loading: gridLoading, error: gridError, data: gridData } = useQuery(USER_MANAGER_GRID_MATRIX_QUERY, {variables: {}});

    useEffect(() => {
        if (gridData) {
            // when grid data has loaded
        }
    }, [gridData]);

    return (
        <UserManagerPage page={'grid-matrix'}>
            grid matrix
        </UserManagerPage>
    )
}

export default UserManagerGridMatrix;
